module.exports = __webpack_public_path__ + "img/jr3.7de60f6e.jpg";